import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { EntryEntity } from '../constants/entries';
interface IUseGetMatterOrInvoiceTransactions {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number | undefined>;
  limit?: number;
  search?: string;
  id?: string;
  fields?: string[];
  type: string;
}
export const useGetMatterOrInvoiceTransactions = (params: IUseGetMatterOrInvoiceTransactions) => {
  const fetchMatterOrInvoiceTransactions = async ({ pageParam = 1 }) => {
    const { relations: invoiceRelations, id, type, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      if (value) queryString.append(`filter.${key}`, String(value));
    });

    (invoiceRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    const url =
      type === EntryEntity.MATTER
        ? `${API_URLS.MATTER_TRANSACTIONS.replace(':id', String(id))}?${queryString.toString()}`
        : `${API_URLS.INVOICE_TRANSACTIONS.replace(':id', String(id))}?${queryString.toString()}`;
    try {
      return await get(url);
    } catch (error) {
      console.error('Error fetching matter invoice transactions:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch matter invoice transactions',
      );
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['matter-invoice-transactions', params],
    queryFn: fetchMatterOrInvoiceTransactions,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    refetch,
    isFetching,
  };
};
